import { Http } from './http';
import { AdminOptionCats, AdminSettingsOption } from '@types';
import { CxSurveyQuestionProps, OptionItemProps, SurveyQuestionType } from '@pages/admin-settings/Survey';

class AdminSettingsHttp extends Http {
  async getSurvey(
    category?: CxQuestionCategory,
  ): Promise<CxSurveyResponse | CxSurveyQuestionResponseProps[]> {
    const url = category
      ? `admin-settings/survey?category=${encodeURIComponent(category)}`
      : 'admin-settings/survey';
    const res = await this.get<CxSurveyResponse>(url);

    return res.data;
  }

  async setSurvey(
    questions: CxSurveyQuestionProps[],
    category: CxQuestionCategory,
  ): Promise<CxSurveyResponse> {
    const res = await this
      .post<CxSurveyResponse>('admin-settings/survey', { questions, category });

    return res.data;
  }

  async getOptionsByCategory(category: AdminOptionCats): Promise<AdminSettingsOption[]> {
    let url = 'admin-settings-options';
    url += category ? `?category=${encodeURIComponent(category)}` : '';
    const res = await this.get<{ list: AdminSettingsOption[] }>(url);

    return res.data.list;
  }

  async setOptions(options: SaveSettingsOption[]): Promise<AdminSettingsOption[]> {
    const url = 'admin-settings-options';
    const res = await this.post<{ list: AdminSettingsOption[] }>(url, { options });

    return res.data.list;
  }

  async mergeOptions(data: SaveSettingsMergeProps): Promise<AdminSettingsOption[]> {
    const url = 'admin-settings-options/merge';
    const res = await this.post<{ list: AdminSettingsOption[] }>(url, data);

    return res.data.list;
  }

  async deleteOptions(ids: number[]): Promise<boolean> {
    const params = new URLSearchParams();
    ids.forEach(id => params.append('ids', `${id}`));

    const url = `admin-settings-options?${params.toString()}`;
    const res = await this.delete<boolean>(url);

    return res.data;
  }
}

export const adminSettingsHttp = new AdminSettingsHttp();

export interface CxSurveyQuestionResponseProps {
  id: number;
  answer: string | null;
  answeredByUser: boolean;
  category: string;
  isEnabled: boolean;
  isRequired: boolean;
  name: string;
  nameClient: string;
  options: OptionItemProps[] | null;
  position: number;
  type: SurveyQuestionType;
}

export interface CxSurveyResponse {
  questionsWelcomeCall: CxSurveyQuestionResponseProps[];
  questionsFollowUp: CxSurveyQuestionResponseProps[];
}

export enum CxQuestionCategory {
  WELCOME_CALLS = 'Welcome Calls',
  FOLLOW_UP = 'Follow Up',
}

export interface SaveSettingsOption {
  name: string;
  category: AdminOptionCats;
  position: number;
  isEnabled: boolean;
}

export interface SaveSettingsMergeProps {
  idsToRemove: number[];
  mainId: number;
  category: AdminOptionCats;
}
